import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react/display-name */
import { useState, useEffect } from 'react';
import destructure from '../utils/destructure';
// wrapper around all consumer implementations. Keeps state in which component is currently shown and which not.
// Every child consumer component can be hidden by calling this.props.close() callback. Each consumer will be shown
// when a related message has arrived. The component below assumes that when a meesage is received, it is applicable
// for it so we show it. Currently the filtering / routing logic is done in the BrazeProvider, although a better approach would
// be probably to delegate it to each consumer since any change in the provider implementation (for example changing consumers[type].each
// to consumers.each) should not brake the child components logic.
const BrazeConsumer = ({ placement, subscribeConsumer, openComponent: OpenComponent, emptyComponent: EmptyComponent, trackingLibrary, }) => {
    const [componentProps, setComponentProps] = useState({});
    const [open, setOpen] = useState(false);
    // incoming data sets consumer's status to opened (so it is shown) and saves the payload in order to forward
    // it to the concrete consumer (See teaser consumer).
    const handleIncomingData = (payload, section) => {
        if (!open) {
            setComponentProps({
                payload: destructure(placement, payload),
                section,
            });
            setOpen(true);
        }
    };
    const handleClose = () => {
        setOpen(false);
    };
    useEffect(() => {
        if (subscribeConsumer) {
            const unsubscribe = subscribeConsumer(placement, handleIncomingData);
            return unsubscribe;
        }
    }, []);
    if (open) {
        return (
        // @ts-ignore
        _jsx(OpenComponent, { close: handleClose, trackingLibrary: trackingLibrary, ...componentProps }));
    }
    else {
        return _jsx(EmptyComponent, {});
    }
};
export { BrazeConsumer };
//# sourceMappingURL=BrazeConsumer.js.map